<template>
  <div class="appmain" :style="`height: calc(100vh - ${headerH}px);`">
    <div style="height: 100%; padding-top: 10px;">
      <transition name=" fade-transform" mode="out-in">
        <!-- <keep-alive> -->
        <router-view />
        <!-- </keep-alive> -->
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "appmainView",
  props: {
    headerH: {
      type: Number,
      default: 76,
    }
  },
  data() {
    return {};
  },
  // 监听页面滚动时触发
  mounted() {

  }
};
</script>

<style scoped>
.appmain {
  background-color: #f5f5f5;
  padding: 0 20px 20px;
  box-sizing: border-box;
}
</style>